import * as moment from "moment";
import { FC, createRef, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import * as yup from "yup";
import pdfIcon from "../../../assets/images/pdfBiomeIcon.svg";
import HasPermission from "../../../core/guards/has-permission";
import HeatmapHighChartComponent from "../../../shared/custom-highchart-component/heatmap-highchart.component";
import CustomSpinnerComponent from "../../../shared/custom-spinner/custom-spinner.component";
import FilterFormComponent, {
  Control,
  FilterFormConfig,
} from "../../../shared/filter-form/filter-form.component";
import { useAppDispatch } from "../../../store/hooks";
import {
  downloadMotionHeatMapReportsFile,
  setFilterFormConfig,
} from "../../../store/slices/fault-module/motion-heat-map-report.slice";
import { getAllFloorsByBlockCode } from "../../../store/slices/floor.slice";
import {
  getBlocksBySiteCode,
  setBlockOptionsData,
} from "../../../store/slices/location-block.slice";
import {
  getSiteByTCCode,
  setSiteOptionsData,
} from "../../../store/slices/location-site.slice";
import { getTownCouncils } from "../../../store/slices/town-council.slice";

import { B2Button } from "@hdb/biome-2";
import { AssetDisplayLevelChartType } from "src/core/enums/dashboard-enums";
import { TIMEVSSENSOR } from "src/shared/helpers/current-month";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";
import { assetsByBlock } from "src/store/slices/asset.slice";
import { getassetDisplayLevelAndLocationsByBlock } from "src/store/slices/dashboard.slice";
import spreadsheetIcon from "../../../assets/images/spreadsheetIconBiome.svg";
interface MotionHeatMapReporTableComponentProps {
  timeVsSensorNodeData: any;
  timeVsLocationData: any;
  onRefetchData: (
    tcCode: any,
    siteCode: any,
    blockCode: any,
    location: any,
    reportType: any,
    startDate: any,
    // endDate: any,
    floorPlan: any,
    asset: any,
  ) => void;
  isLoading: boolean;
  sensorTickPositions: string[];
  locationTickPositions: string[];
  timeVsSensorNodeExtraData?: any;
}

const MotionHeatMapReporTableComponent: FC<
  MotionHeatMapReporTableComponentProps
> = ({
  timeVsSensorNodeData,
  timeVsLocationData,
  onRefetchData,
  isLoading,
  sensorTickPositions,
  locationTickPositions,
  timeVsSensorNodeExtraData,
}) => {
    const dispatch = useAppDispatch();
    const formRef = createRef();

    const [tcOptions, setTCOptions] = useState<any>([]);
    const [siteOptions, setSiteOptions] = useState<any>([]);
    const [blockOptions, setBlockOptions] = useState<any>([]);
    const [levelAndLocationOptions, setLevelAndLocationOptions] = useState<any>(
      [],
    );

    const [selectedTC, setSelectedTC] = useState<any>(null);
    const [selectedSite, setSelectedSite] = useState<any>(null);
    const [selectedBlock, setSelectedBlock] = useState<any>(null);
    const [selectedtLevelOrLoction, setSelectedtLevelOrLoction] =
      useState<any>(null);
    const [selectedAsset, setSelectedAsset] = useState<any>(null);

    const [isAssetSearch, setIsAssetSearch] = useState<boolean>(true);
    const [assetOptions, setAssetOptions] = useState<any>([]);
    const [blockChangeDetected, setBlockChangeDetected] = useState(0);

    const [sensorSelected, setSensorSelected] = useState(false);
    const [isExportDisabled, setIsExportDisabled] = useState<boolean>(false);

    const assetsData = useSelector((state: any) => {
      return state.asset.selectedAssetsByBlock;
    });

    const assetDisplayLevelAndLocationsByBlockData = useSelector((state: any) => {
      return state.dashboard.assetDisplayLevelAndLocationsByBlock;
    });

    useEffect(() => {
      const assetIDs =
        assetsData?.map(
          (asset: { assetCode: string; sensorDisplayName: string }) => ({
            label: asset.sensorDisplayName,
            value: asset.assetCode,
          }),
        ) || [];

      if (assetIDs?.length > 0) {
        assetIDs.unshift({
          label: "All",
          value: null,
        });
      }

      setAssetOptions(assetIDs);

      if (assetsData.length > 0) {
        setIsAssetSearch(false);
      }
    }, [assetsData]);

    useEffect(() => {
      const options = assetDisplayLevelAndLocationsByBlockData?.map((d: any) => ({
        label: d.DisplayLevel,
        value: d.DisplayLevel,
      }));
      setLevelAndLocationOptions(options);
    }, [assetDisplayLevelAndLocationsByBlockData]);

    const filterFormConfig = useSelector(
      (state: any) => state.motionHeatMapReport.filterFormConfig,
    );

    const isLoadingTownCouncils = useSelector((state: any) => {
      return state.townCouncil.isLoadingTownCouncils;
    });

    const isLocationSitesByTCCode = useSelector((state: any) => {
      return state.locationSite.isLocationSitesByTCCode;
    });

    const isLoadingBlocksBySiteCode = useSelector((state: any) => {
      return state.locationBlock.isLoadingBlocksBySiteCode;
    });

    const isLoadingAssetDisplayLevelAndLocationsByBlock = useSelector(
      (state: any) => {
        return state.dashboard.isLoadingAssetDisplayLevelAndLocationsByBlock;
      },
    );

    // let localFilterFormConfig: any;

    // const [floorPlanOptions, setFloorPlanOptions] = useState<any>([]);
    const [isFiltered, setIsFiltered] = useState<any>(false);
    const [selectedReportType, setSelectedReportType] = useState<any>(null);
    const [downloaDocumentPayload, setDownloaDocumentPayload] = useState<any>({
      townCouncil: "",
      site: "",
      block: "",
      location: "",
      reportType: "",
      startDate: "",
      floorPlan: "",
    });

    const [filterUpdateCount, setFilterUpdateCount] = useState(0);

    useEffect(() => {
      dispatch(setSiteOptionsData([]));
      dispatch(setBlockOptionsData([]));
      setAssetOptions([]);
      setIsAssetSearch(true);
    }, []);

    const onChangeTC = (selectedTC: any) => {
      // setFloorPlanOptions([]);
      setSiteOptions([]);
      setBlockOptions([]);
      setLevelAndLocationOptions([]);
      setAssetOptions([]);

      setSelectedSite(null);
      setSelectedBlock(null);
      setSelectedtLevelOrLoction(null);
      setSelectedAsset(null);

      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        townCouncil: selectedTC,
        site: "",
        block: "",
        location: "",
        asset: "",
      }));

      setBlockChangeDetected(blockChangeDetected + 1);
      if (!selectedTC) return;

      setSelectedTC(selectedTC);
      setIsAssetSearch(true);
      dispatch(getSiteByTCCode({ tcCode: selectedTC }));
    };

    const onChangeSite = (selectedSite: any) => {
      // setFloorPlanOptions([]);
      setBlockOptions([]);
      setLevelAndLocationOptions([]);

      setSelectedBlock(null);
      setSelectedtLevelOrLoction(null);
      setIsAssetSearch(true);
      setSelectedAsset(null);

      setAssetOptions([]);
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        site: selectedSite,
        block: "",
        location: "",
        asset: "",
      }));

      setBlockChangeDetected(blockChangeDetected + 1);
      setSelectedSite(selectedSite);

      dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
    };

    const onChangeBlock = (selectedBlock: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        block: selectedBlock,
        location: "",
        asset: "",
      }));

      setLevelAndLocationOptions([]);
      // setFloorPlanOptions([]);
      setAssetOptions([]);

      setSelectedtLevelOrLoction(null);
      setSelectedAsset(null);

      setBlockChangeDetected(blockChangeDetected + 1);

      setSelectedBlock(selectedBlock);
      dispatch(getAllFloorsByBlockCode({ blockCode: selectedBlock }));

      dispatch(
        getassetDisplayLevelAndLocationsByBlock({
          blockCode: selectedBlock,
          chartType: AssetDisplayLevelChartType.Motion,
        }),
      );
    };

    const onChangeLevelOrLocation = (selectedLocation: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        location: selectedLocation,
        asset: "",
      }));

      // setFloorPlanOptions([]);
      setAssetOptions([]);
      setSelectedAsset(null);

      setBlockChangeDetected(blockChangeDetected + 1);

      setSelectedtLevelOrLoction(selectedLocation);
    };

    useEffect(() => {
      if (selectedTC && selectedSite && selectedBlock) {
        dispatch(assetsByBlock({ blockCode: selectedBlock }));
      }
    }, [selectedBlock]);

    useEffect(() => {
      if (
        selectedTC &&
        selectedSite &&
        selectedBlock &&
        selectedtLevelOrLoction
      ) {
        dispatch(
          assetsByBlock({
            blockCode: selectedBlock,
            location: selectedtLevelOrLoction,
          }),
        );
      }
    }, [selectedtLevelOrLoction]);

    const onChangeAsset = (selectedAsset: any) => {
      setSelectedAsset(selectedAsset);
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        asset: selectedAsset,
      }));
    };

    const onChangeReportType = (selectedReportType: any) => {
      if (selectedReportType === TIMEVSSENSOR) {
        setSensorSelected(true);
      } else {
        setSensorSelected(false);
        setSelectedAsset(null);
        setSelectedtLevelOrLoction(null);
      }

      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        reportType: selectedReportType,
      }));
    };

    const reportTypeOptions = [
      {
        label: "Time vs Sensor",
        value: 1,
      },
      {
        label: "Time vs Level",
        value: 2,
      },
    ];

    const date13MonthsAgo = moment().subtract(13, "months").format("YYYY-MM-DD");
    const yesterdayDateTime = moment().subtract(1, "day").format("YYYY-MM-DD");

    const onChangeStartDate = (startDate: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        startDate: startDate,
      }));
    };

    useEffect(() => {
      dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
    }, [dispatch]);

    const townCouncilData = useSelector((state: any) => {
      return state.townCouncil.townCouncils;
    });

    const siteDataByTCCode = useSelector((state: any) => {
      return state.locationSite.sitesByTCCode;
    });

    const blockDataSiteCode = useSelector((state: any) => {
      return state.locationBlock.blocksBySiteCode;
    });

    /*     const floorDataBlockCode = useSelector((state: any) => {
          return state.floor.floorByBlockCode;
        }); */

    const isLoadingMotionHeatmapReportsDownload = useSelector((state: any) => {
      return state.motionHeatMapReport.isLoadingMotionHeatmapReportsDownload;
    });

    const [currentTC, setCurrentTC] = useState({ label: "", value: "" });

    useEffect(() => {
      const tcs = townCouncilData?.data?.map((tc: any) => ({
        label: tc?.name,
        value: tc?.tcCode,
      }));

      // if user is TC Admin only 1 tc is available
      if (tcs?.length === 1) {
        setCurrentTC(tcs[0]);
      }
      setTCOptions(tcs);
      setFilterUpdateCount(filterUpdateCount + 1);
    }, [townCouncilData]);

    useEffect(() => {
      if (currentTC.value.length) {
        setFormFilterInitialValues((prev) => ({
          ...prev,
          townCouncil: currentTC.value,
        }));

        dispatch(getSiteByTCCode({ tcCode: currentTC.value }));
      }
    }, [currentTC]);

    useEffect(() => {
      const sites = siteDataByTCCode?.data?.map((site: any) => ({
        label: site?.name,
        value: site?.siteCode,
      }));

      if (!sites?.length) return;

      setSiteOptions(sites);
    }, [siteDataByTCCode]);

    useEffect(() => {
      const blocks = blockDataSiteCode?.data?.map((block: any) => ({
        label: block?.blockName,
        value: block?.blockCode,
      }));

      setBlockOptions(blocks);
    }, [blockDataSiteCode]);

    /*     useEffect(() => {
          const floors = floorDataBlockCode?.data?.map((floor: any) => ({
            label: floor?.FloorCode,
            value: floor?.floorCode,
          }));
    
          // setFloorPlanOptions(floors);
        }, [floorDataBlockCode]); */

    useEffect(() => {
      const controls: { controlGroup: Control[] }[] = [
        {
          controlGroup: [
            {
              name: "townCouncil",
              placeholder: "Select Town Council *",
              type: "searchable-select",
              options: tcOptions,
              onChange: onChangeTC,
              required: true,
              isLoading: isLoadingTownCouncils,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "site",
              placeholder: "Select Site *",
              type: "searchable-select",
              options: siteOptions,
              onChange: onChangeSite,
              required: true,
              isLoading: isLocationSitesByTCCode,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "block",
              placeholder: "Select Block *",
              type: "searchable-select",
              options: blockOptions,
              onChange: onChangeBlock,
              required: true,
              isLoading: isLoadingBlocksBySiteCode,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "reportType",
              placeholder: "Select Report Type *",
              type: "select",
              options: reportTypeOptions,
              required: true,
              onChange: onChangeReportType,
              isLoading: false,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "startDate",
              placeholder: "Select Date *",
              type: "date",
              onChange: onChangeStartDate,
              required: true,
              isLoading: false,
              minDate: date13MonthsAgo,
              maxDate: yesterdayDateTime,
            },
          ],
        },
      ];

      if (sensorSelected) {
        controls.push(
          {
            controlGroup: [
              {
                name: "location",
                placeholder: "Select Level Or Location",
                type: "searchable-select",
                options: levelAndLocationOptions,
                onChange: onChangeLevelOrLocation,
                required: true,
                isLoading: isLoadingAssetDisplayLevelAndLocationsByBlock,
              },
            ],
          },
          {
            controlGroup: [
              {
                name: "asset",
                placeholder: "All Assets",
                type: "searchable-select",
                required: false,
                selectType: "single",
                options: assetOptions,
                onChange: onChangeAsset,
                // onInputChange: onTypeAheadInputChange,
                isLoading: true,
                disabled: isAssetSearch,
                resetSearchableSelect: blockChangeDetected,
              },
            ],
          },
        );
      }

      const config: FilterFormConfig = {
        controls: controls,
      };

      dispatch(setFilterFormConfig(config));
    }, [
      !isAssetSearch,
      tcOptions,
      siteOptions,
      blockOptions,
      sensorSelected,
      assetOptions,
      levelAndLocationOptions,
    ]);

    useEffect(() => {
      // localFilterFormConfig = filterFormConfig;

      let json = JSON.stringify(filterFormConfig, function (key, value) {
        if (typeof value === "function") {
          return value.toString();
        } else {
          return value;
        }
      });

      localStorage.setItem("filterFormConfig", json);
    }, [filterFormConfig]);

    useEffect(() => {
      if (selectedReportType) {
        let isDataEmpty = false;

        switch (selectedReportType.toString()) {
          case "1":
            isDataEmpty = !timeVsSensorNodeData?.identicalStringsList?.length;
            break;
          case "2":
            isDataEmpty = !timeVsLocationData?.identicalStringsList?.length;
            break;
          default:
            break;
        }

        setIsExportDisabled(isDataEmpty);
      } else {
        setIsExportDisabled(false);
      }
    }, [selectedReportType, timeVsSensorNodeData, timeVsLocationData]);

    const onSubmitFilter = () => {
      const form: any = formRef.current;

      if (form) {
        form.handleSubmit();

        const {
          townCouncil,
          site,
          block,
          location,
          reportType,
          startDate,
          asset,
          floorPlan,
        } = form.values;

        if (!reportType || !townCouncil || !site || !block || !startDate) {
          setIsFiltered(false);
          return;
        }

        setIsFiltered(true);
        setSelectedReportType(reportType);

        if (
          townCouncil ||
          site ||
          block ||
          location ||
          reportType ||
          startDate ||
          asset ||
          floorPlan
        ) {
          onRefetchData(
            townCouncil ? townCouncil : null,
            site ? site : null,
            block ? block : null,
            location && selectedtLevelOrLoction !== "All Level"
              ? selectedtLevelOrLoction
              : null,
            reportType ? reportType : null,
            startDate ? moment.utc(startDate) : null,
            floorPlan ? floorPlan : null,
            asset ? selectedAsset : null,
          );

          setDownloaDocumentPayload({
            townCouncil,
            site,
            block,
            location,
            reportType,
            startDate,
            floorPlan,
            asset,
          });
        }
      }
    };

    const onClickDownload = (fileType: any) => {
      const form: any = formRef.current;

      if (form) {
        const {
          townCouncil,
          site,
          block,
          location,
          reportType,
          startDate,
          floorPlan,
          asset,
        } = downloaDocumentPayload;

        if (!reportType || !townCouncil || !site || !block || !startDate) {
          return;
        }

        dispatch(
          downloadMotionHeatMapReportsFile({
            fileType,
            tcCode: townCouncil ? townCouncil : null,
            siteCode: site ? site : null,
            blockCode: block ? block : null,
            location: location ? location : null,
            reportType: reportType ? reportType : null,
            startDate: startDate ? moment.utc(startDate) : null,
            floorPlan: floorPlan ? floorPlan : null,
            asset: asset ? asset : null,
          }),
        );
      }
    };

    const [formFilterInitialValues, setFormFilterInitialValues] = useState({
      townCouncil: "",
      site: "",
      block: "",
      reportType: "",
      startDate: "",
      floorPlan: "",
      asset: "",
    });

    const onReset = () => {
      const form: any = formRef.current;
      form.resetForm();

      setSiteOptions([]);
      setBlockOptions([]);

      setIsAssetSearch(true);
      setIsFiltered(false);
      setFilterUpdateCount(filterUpdateCount + 1);

      setSelectedTC(null);
      setSelectedSite(null);
      setSelectedBlock(null);
      setBlockChangeDetected(0);
      setSensorSelected(false);
      setFormFilterInitialValues({
        townCouncil: "",
        site: "",
        block: "",
        reportType: "",
        startDate: "",
        floorPlan: "",
        asset: "",
      });
    };

    const filterActionConfig: any = {
      label: "Search",
      event: onSubmitFilter,
      variant: "primary",
    };

    const reset: any = {
      label: "Reset",
      event: onReset,
      variant: "secondary",
    };

    const validationSchema = yup.object().shape({
      reportType: yup.number().required("Report Type is required"),
      townCouncil: yup.string().required("Town Council is required"),
      site: yup.string().required("Site is required"),
      block: yup.string().required("Block is required"),
      startDate: yup.string().required("Start Date is required"),
    });

    return (
      <div>
        <div>
          {!!filterFormConfig && Object?.keys(filterFormConfig)?.length > 0 && (
            <FilterFormComponent
              key={formFilterInitialValues?.townCouncil}
              formRef={formRef}
              initialValues={formFilterInitialValues}
              formConfig={filterFormConfig}
              actionConfig={filterActionConfig}
              resetButton={reset}
              validation={validationSchema}
              filterFormMutationFunction={setFilterFormConfig}
              filterUpdateCount={filterUpdateCount}
            />
          )}
        </div>
        <div>
          <CustomSpinnerComponent
            height={"400px"}
            width={"100%"}
            isLoading={isLoading}
          >
            {isFiltered ? (
              <div className="my-3">
                <div className="export pt-4 d-flex align-items-center justify-content-end">
                  <HasPermission
                    moduleName="Motion Heat Map Report"
                    actionName="Download-Motion Heat Map Report"
                    isRoute={false}
                  >
                    <div className="d-flex gap-2">
                      <B2Button
                        variant="light"
                        onClick={() => onClickDownload("downloadPdf")}
                        disabled={isExportDisabled}
                      >
                        <img className="fs-7 ms-2" src={pdfIcon} alt="PDF Icon" />{" "}
                        Export as PDF
                      </B2Button>

                      <B2Button
                        variant="light"
                        onClick={() => onClickDownload("downloadExcel")}
                        disabled={isExportDisabled}
                      >
                        <img
                          className="fs-7 me-2"
                          src={spreadsheetIcon}
                          alt="Spreadsheet Icon"
                        />{" "}
                        Export as Excel
                      </B2Button>
                    </div>

                    {isLoadingMotionHeatmapReportsDownload ? (
                      <Spinner
                        className="ms-2"
                        style={{ color: "#1976D2" }}
                        animation="border"
                        role="status"
                        size="sm"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : null}
                  </HasPermission>
                </div>
                {selectedReportType == 1 ? (
                  <HeatmapHighChartComponent
                    chartTitle="Motion Heatmap"
                    seriesData={timeVsSensorNodeData}
                    extraData={timeVsSensorNodeExtraData}
                    tickPositions={sensorTickPositions}
                    xAxisTitle="Sensors"
                    yAxisTitle="Time(hours)"
                    chartType="Sensor"
                    fileName={generateFilenameWithTimestamp("Motion Heatmap")}
                    chartName={"Motion Heatmap"}
                  />
                ) : (
                  <HeatmapHighChartComponent
                    chartTitle="Motion Heatmap"
                    seriesData={timeVsLocationData}
                    tickPositions={locationTickPositions}
                    xAxisTitle="Level"
                    yAxisTitle="Time(hours)"
                    chartType="Level"
                    fileName={generateFilenameWithTimestamp("Motion Heatmap")}
                    chartName={"Motion Heatmap"}
                  />
                )}
              </div>
            ) : (
              <></>
            )}
          </CustomSpinnerComponent>
        </div>
      </div>
    );
  };

export default MotionHeatMapReporTableComponent;
